import { FC, useEffect, useRef } from "react";
import "../../../styles/components.css";
import { StandardHandler } from "../../../middleware/handlers/standard-handler";

interface ModelTreeMenuProps {
  modelTreePanelReveal: boolean;
}

export const ModelTreeMenu: FC<ModelTreeMenuProps> = ({
  modelTreePanelReveal,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    if (modelTreePanelReveal) {
      StandardHandler.MountModelTreePanel(container);
    } else {
      StandardHandler.UnmountModelTreePanel();
    }

    return () => {
      StandardHandler.UnmountModelTreePanel();
    };
  }, [modelTreePanelReveal]);

  if (!modelTreePanelReveal) return null;

  return (
    <div id="modelTreeMenu">
      <div id="modelTreeWrapper" ref={containerRef} />
    </div>
  );
};

export default ModelTreeMenu;
